'use client';

import { useState, type FormEvent } from 'react';

import AccountInput from '@/app/account/_components/AccountInput';
import { ReactComponent as EnvelopeIcon } from '@/public/svgs/global/Icons/Paper_Plane.svg';

import styles from './ForgotPassword.module.scss';

export default function RecoveryRequestForm(): JSX.Element {
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [unavailable, setUnavailable] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    if (pending)
      return;

    setPending(true);
    setUnavailable(false);
    try {
      const response = await fetch('/api/account/recovery/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (!response.ok) {
        setUnavailable(true);
        return;
      }
      setSubmitted(true);
    } catch {
      setUnavailable(true);
    } finally {
      setPending(false);
    }
  }

  return (
    <form className={ styles.resetForm } onSubmit={ submit }>
      <AccountInput
        id='accountEmail'
        label='Account Email'
        name='accountEmail'
        type='email'
        placeholder='name@company.com'
        hasIcon
        leadingIcon={ <EnvelopeIcon /> }
        autoComplete='email'
        required
        value={ email }
        onChange={ (event) => setEmail(event.target.value) }
      />
      <button className={ styles.resetButton } type='submit' disabled={ pending || submitted }>
        { pending ? 'Sending…' : 'Send reset instructions' }
      </button>
      { submitted && <p role='status'>If that account exists, we sent password reset instructions to its email address.</p> }
      { unavailable && <p role='alert'>We could not send reset instructions right now. Please try again shortly.</p> }
    </form>
  );
}
